import { useQuery } from "@tanstack/react-query";
import { match, P } from "ts-pattern";
import { API } from "../../../API";
import { useSocket } from "../../../hooks/useSocket";
import { AppState } from "../../../system/AppState";
import { AppChatState, ChatSystemStrategies } from "../../../system/AppState/ChatState";
import { QueryStatus } from "../../../utils/reactQueryUtils";
import { chatTicketsQueryKey } from "../../Chat/ChatMainScreen/ChatMainActivity";
import { getTotalUnreadMessages } from "../../Chat/utils/chatUtils";

interface Props {
  api: API;
  appState: AppState;
  appChatState: AppChatState;
  chatSystemStrategies: ChatSystemStrategies;
  isNewChatScreen: boolean;
}

function useTotalNewChatMessagesCount(props: Props) {
  const query = useQuery({
    queryKey: chatTicketsQueryKey,
    queryFn: () => props.api.getChatTickets(),
  });

  useSocket({
    eventName: "CommCenterTicketUpdated",
    onEvent: () => {
      console.log("[useTotalNewChatMessagesCount] CommCenterTicketUpdated");
      query.refetch();
    },
  });

  if (props.isNewChatScreen) {
    return match(query)
      .with(P.union(QueryStatus.Loading, QueryStatus.Idle, QueryStatus.Error), () => 0)
      .with(QueryStatus.ResolvedAs("data"), (result) => getTotalUnreadMessages(result.data.tickets))
      .exhaustive();
  }

  return AppChatState.numNewChatMessages(props.appChatState, props.chatSystemStrategies);
}

export default useTotalNewChatMessagesCount;
